import type { Id } from './types';

/** Po tylu ms bez odhaczeń uznajemy, że ktoś skończył zakupy, nawet jeśli nie kliknął „Zakończ”. */
export const VISIT_IDLE_MS = 2 * 60 * 60 * 1000;

export interface VisitLike {
  userId?: Id | null;
  deviceId: Id;
  startedMs: number;
  finishedMs: number | null;
  deleted?: boolean | null;
}

export interface ItemActivity {
  checkedBy?: Id | null;
  checkedMs: number | null;
}

/**
 * Czy wizyta trwa: niezamknięta i jej właściciel coś odhaczył (albo zaczął) w ciągu ostatnich 2 h.
 * Aktywność liczona per użytkownik, bo na wspólnej liście odhacza kilka osób.
 * Ta sama reguła działa w PWA („kto jest w sklepie”) i na serwerze (komu wysłać powiadomienie).
 */
export function isVisitOpen(visit: VisitLike, items: readonly ItemActivity[], nowMs: number): boolean {
  if (visit.deleted || visit.finishedMs !== null) return false;
  let last = visit.startedMs;
  for (const i of items) {
    if (i.checkedMs === null) continue;
    if (visit.userId && i.checkedBy && i.checkedBy !== visit.userId) continue;
    if (i.checkedMs > last) last = i.checkedMs;
  }
  return nowMs - last <= VISIT_IDLE_MS;
}
